// Preferred wedding suppliers for Gledswood Homestead & Winery.
// Data sourced from the venue's official preferred suppliers list.

export const EMAIL_SUBJECT = "Gledswood Referred Enquiry";
export const EMAIL_BODY =
  "Hello,\n\nWe are in the early stages of planning our wedding and received your details from the Gledswood Events Team.\n\nWe would be grateful if we could make a time to chat about our wedding.\n\nThank you!";

export const buildMailto = (email) =>
  `mailto:${email}?subject=${encodeURIComponent(EMAIL_SUBJECT)}&body=${encodeURIComponent(
    EMAIL_BODY
  )}`;

export const normalizeUrl = (url) => {
  if (!url) return null;
  return url.startsWith("http") ? url : `https://${url}`;
};

export const instagramUrl = (handle) => {
  if (!handle) return null;
  return `https://instagram.com/${handle.replace(/^@/, "")}`;
};

const s = (name, email, website, socials, discount = null) => ({
  name,
  email,
  website,
  socials,
  discount,
});

export const CATEGORIES = [
  {
    name: "Animals & Pets",
    image: "/categories/animals-pets.webp",
    suppliers: [
      s("Alpaca Kisses", "maria@alpacakisses.com", "www.alpacakisses.com", "@alpacakisses2u"),
      s("Pets as Guests", "petsasguests@hotmail.com", "www.petsasguests.com", "@petsasguests"),
      s("Pawz & Me", "hello@pawzandme.com.au", "www.pawsandme.com", "@pawzandme"),
    ],
  },
  {
    name: "Bridal Wear",
    image: "/categories/bridal-wear.jpg",
    suppliers: [
      s("Ruth Fattal Haute Couture", "shop@ruthfattal.com.au", "www.ruthfattal.com.au", "@ruthfattalhautecouture"),
      s("Love Marie Bridal", "appointments@lovemarie.com.au", "www.lovemarie.com.au", "@lovemariebridalboutique"),
    ],
  },
  {
    name: "Cakes",
    image: "/categories/cakes.jpg",
    suppliers: [
      s("Sweet Reign Cake Co", "sweetreigncake@outlook.com", null, "@sweetreigncakeco"),
      s("Desserts By Demi", "dessertsbydemi@outlook.com", null, "@dessertsbydemi"),
      s("The Sugar Brook", null, "www.thesugarbrook.com.au", "@thesugarbrook"),
    ],
  },
  {
    name: "Celebrant",
    image: "/categories/celebrant.jpg",
    suppliers: [
      s("Kylie Wilson", "enquiry@arrivalsmarriagesdepartures.com.au", "www.arrivalsmarriagesdepartures.com.au", "@arrivalsmarriagesdepartures"),
      s("Chris Bragg", "chrisbraggcelebrant@gmail.com", null, "@chris_bragg_celebrant"),
      s("Cass Fisher", "contact@ceremoniesbycassandra.com.au", "www.ceremoniesbycassandra.au", "@ceremoniesbycassandra"),
      s("Wedding Dells", "del@weddingdells.com.au", "www.weddingdells.com.au", "@weddingdells"),
      s("Divine Celebrancy", "hello@divinecelebrancy.com.au", "www.divinecelebrancy.com.au", "@divinecelebrancy"),
      s("Jordan Vassallo", "info@jordanvassallocelebrant.com.au", "www.jordanvassallocelebrant.com.au", "@jordanvassallocelebrant"),
      s("David Lang", "davidlangcelebrant@gmail.com", "www.davidlangcelebrant.com", "@davidlangcelebrant"),
      s("James Stephen", "jamesstephencelebrant@gmail.com", "www.jamesstephencelebrant.com", "@jamesstephencelebrant"),
      s("Life Celebrations by Samantha", "lifecels@gmail.com", "www.lifecelebrationsbysamantha.com", "@samanthalysaughtcelebrant"),
      s("Suzie Crozier", "suzie@thefeelgoodweddingco.com.au", "www.thefeelgoodweddingco.com.au", "@feelgoodweddingco"),
      s("Carolyn Clarke", null, "www.celebrantservices4u.com.au", "@carolynclarkecelebrant"),
      s("Married By Nicole", "nicole@marriedbynicole.com", "www.marriedbynicole.com", "@married.by.nicole"),
    ],
  },
  {
    name: "Coffee Van",
    image: "/categories/coffee-van.png",
    suppliers: [
      s("Deja Brew Express", "deja_brew_coffee@outlook.com.au", null, "@dejabrewexpresscoffee"),
      s("Orions Minty Coffee", "orionsmintyleaf@gmail.com", null, "@orionsmintyleafcoffee"),
    ],
  },
  {
    name: "DJ & MC",
    image:
      "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    suppliers: [
      s("DJ Dumplings", "info@djdumplings.com", "www.djdumplings.com", "@dj.dumplings"),
      s("Premium DJ's", "premiumdjs@optusnet.com.au", null, "@premiumdjssydney"),
      s("Chris Bragg", "chrisbraggcelebrant@gmail.com", null, "@chris_bragg_celebrant"),
      s("DJ Age", "djage14@gmail.com", "www.djage.com.au", "@djage_"),
      s("Con Pappas MC", "conpappasweddings@gmail.com", null, "@conpappasweddingmc"),
    ],
  },
  {
    name: "Florist & Stylist",
    image: "/categories/florist-stylist.webp",
    suppliers: [
      s("Ab Fab Events", "events@abfabevents.com.au", null, "@ab_fab_weddings"),
      s("Allure Events Sydney", "info@allureeventssydney.com.au", "www.allureeventssydney.com.au", "@allureeventssydney"),
      s("Oak & Blossom", null, "www.oakandblossomevents.com.au", "@oakandblossomevents"),
      s("Eden Flower Studio", "info@edenflowerstudio.com.au", "www.edenflowerstudio.com.au", "@edenflowerstudioflorist"),
      s("Lavender & Willow", "marisapacho5@gmail.com", null, "@lavendarandwillowbymarisa"),
      s("Petals & Props", null, null, "@petalpropevents"),
      s("The Eventful Touch", "theeventfultouch@gmail.com", "www.theeventfultouch.com", "@theeventfultouch"),
      s("Khloris", "khloriscollection@gmail.com", null, "@khloris.official"),
    ],
  },
  {
    name: "Hair & Make Up",
    image: "/categories/hair-makeup.png",
    suppliers: [
      s("Sharon May Bridal Hair", "hello@sharonmay.com.au", "www.sharonmay.com", "@sharonmaybridalhair"),
      s("Serenity Artistry 87", "serenityartistry@gmail.com", null, "@serenityartistry87"),
      s("Daniela Bazdaric Make Up", "info@danielabazdaricartistry.com.au", "www.danielabazdaricartistry.com.au", "@danielabazdaricartistry"),
    ],
  },
  {
    name: "Musician",
    image: "/categories/musician.webp",
    suppliers: [
      s("Karleigh Rose", "karleighrose.info@gmail.com", "www.karleighrosemusic.com", "@karleighrose_"),
      s("Wanita Ann", "wanitaannmusic@gmail.com", "www.wanitaannmusic.com.au", "@wanitaannmusic"),
      s("Russ Flannery Musician", null, null, null),
      s("Strings Attached Ensemble", "thebritishcellist@gmail.com", "www.thebritishcellist.com.au", "@thebritishcellist"),
      s("White Clover Music", "ladykate@live.com.au", "www.whiteclovermusic.com", "@whiteclovermusic"),
    ],
  },
  {
    name: "Photobooth",
    image: "/categories/photobooth.jpg",
    suppliers: [
      s("In The Booth", "sydneywest@inthebooth.com.au", null, "@inthebooth"),
      s("Retro Roma Photobooth", "retroromaphotobooth@gmail.com", "www.retroroma.com.au", "@retro_roma_photobooth"),
      s("The Magic Mirror Sydney", "info@themagicmirrorsydney.com.au", "www.themagicmirrorsydney.com.au", "@magicmirrorsydney"),
      s("Exclusive Photobooths", "info@exclusivebooths.com.au", "www.exclusivebooths.com.au", "@exclusive_booths"),
    ],
  },
  {
    name: "Photographer & Videographer",
    image: "/categories/photographer-videographer.webp",
    suppliers: [
      s("Fortunate Fellow", "info@fortunatefellow.com.au", "www.fortunatefellow.com.au", "@fortunate_fellow"),
      s("Zee & Cee", "admin@zeeandcee.com.au", "www.zeeandcee.com.au", "@zeeandceephotography"),
      s("Neaton Photography", "info@neatonphotography.com.au", "www.neatonphotography.com.au", "@neatonphotography"),
      s("Elysium Photography", "smile@elysiumphotography.com.au", "www.elysiumphotography.com.au", "@elysiumphotography.au"),
      s("Puzzleman Productions", null, "www.puzzlemanproductions.com.au", "@puzzleman_productions"),
      s("By Kevin", "hello@bykevin.com.au", "www.bykevin.com.au", "@_by.kevin"),
      s("Salt Shaker Films", null, "www.saltshakerfilms.com.au", "@saltshakerfilms"),
    ],
  },
  {
    name: "Reception Entertainment",
    image: "/categories/reception-entertainment.jpg",
    suppliers: [
      s("Painted Favours", "paintedfavours@gmail.com", "www.paintedfavours.com.au", "@paintedfavours"),
      s("Wedding Fireworks Sydney", "weddingfireworks.sydney@gmail.com", "www.weddingfireworks.sydney", "@weddingfireworks.sydney"),
      s("Benny The Magician", "bennymannillusionist@gmail.com", "www.bennythemagician.com.au", "@bennythemagician"),
    ],
  },
  {
    name: "Stationery",
    image: "/categories/stationery.jpg",
    suppliers: [
      s(
        "Timberwink Studio",
        null,
        "https://timberwinkstudio.com/collections/wedding-invitation-templates?ref=gledswood",
        "@timberwinkstudio",
        { amount: "10% Off", code: "GLEDSWOOD" }
      ),
      s("Gracie Creative", "liv@graciecreative.com.au", "www.graciecreative.com.au", "@graciecreative_"),
      s("Danielle Tyerman Creative", "danielle.tyerman@gmail.com", null, "@danielletyermancreative"),
    ],
  },
  {
    name: "Transport",
    image: "/categories/transport.webp",
    suppliers: [
      s("I Do Wedding Cars", "info@idoweddingcars.com.au", "www.idoweddingcars.com.au", "@idoweddingcars"),
      s("Platinum Shuttles", "info@platinumshuttles.com.au", "www.platinumshuttles.com.au", "@platinumshuttles"),
      s("Chevs 4 U", null, null, "@chevs4u"),
      s("Castlereagh Carriages", "info@weddingcarriages.com.au", "www.weddingcarriages.com.au", "@castlereagh_wedding_carriages"),
      s("Camden Limousines", "info@camdencarhire.com.au", "www.camdencarhire.com.au", "@camdencarhire"),
    ],
  },
];
